/*
 ######     #######   ##    ##   ########   
##    ##   ##     ##  ###   ##   ##         
##         ##     ##  ####  ##   ##         
##         ##     ##  ## ## ##   ######     
##         ##     ##  ##  ####   ##         
##    ##   ##     ##  ##   ###   ##         
 ######     #######   ##    ##   ##         
*/

/** 
	À décommenter et modifier pour activer un chargement entre les changements de page
	fonctions : showLoader / hideLoader à compléter
	Defaut : false
**/
// pageTransition = true;

/** 
	À décommenter et modifier pour activer le chargement des pages en ajax
	Defaut : false
	Note : les liens qui font appel à un chargement via AJAX doivent contenir l'attribut rel="address"
**/
// pageAjax = true;

/** 
	À décommenter et modifier pour changer le breakpoint activant les animations parallax
	activé par défaut à partir des tablettes (768)
**/
// parallaxBreakpoint = 768;

(function($) {

	/*
	########   ########    ######    ####  ########   ########   
	##     ##  ##         ##    ##    ##        ##    ##         
	##     ##  ##         ##          ##       ##     ##         
	########   ######      ######     ##      ##      ######     
	##   ##    ##               ##    ##     ##       ##         
	##    ##   ##         ##    ##    ##    ##        ##         
	##     ##  ########    ######    ####  ########   ########   
	
	##     ##     ###     ##    ##   ########   ##         ########   ########   
	##     ##    ## ##    ###   ##   ##     ##  ##         ##         ##     ##  
	##     ##   ##   ##   ####  ##   ##     ##  ##         ##         ##     ##  
	#########  ##     ##  ## ## ##   ##     ##  ##         ######     ########   
	##     ##  #########  ##  ####   ##     ##  ##         ##         ##   ##    
	##     ##  ##     ##  ##   ###   ##     ##  ##         ##         ##    ##   
	##     ##  ##     ##  ##    ##   ########   ########   ########   ##     ##  
	*/

	/* Fonctions exécutées à chaque resize */
	var resizeHandler = function() {
		$(window).trigger('scroll');
		initScrollAnimations();
		resizeParallax();
		
		/* Autres fonctions jouées au resize */
		// resizeSlider();
		// resizeNav();
	};

	
	/*
	 ######     ######    ########    #######   ##         ##         
	##    ##   ##    ##   ##     ##  ##     ##  ##         ##         
	##         ##         ##     ##  ##     ##  ##         ##         
	 ######    ##         ########   ##     ##  ##         ##         
	      ##   ##         ##   ##    ##     ##  ##         ##         
	##    ##   ##    ##   ##    ##   ##     ##  ##         ##         
	 ######     ######    ##     ##   #######   ########   ########   
	
	##     ##     ###     ##    ##   ########   ##         ########   ########   
	##     ##    ## ##    ###   ##   ##     ##  ##         ##         ##     ##  
	##     ##   ##   ##   ####  ##   ##     ##  ##         ##         ##     ##  
	#########  ##     ##  ## ## ##   ##     ##  ##         ######     ########   
	##     ##  #########  ##  ####   ##     ##  ##         ##         ##   ##    
	##     ##  ##     ##  ##   ###   ##     ##  ##         ##         ##    ##   
	##     ##  ##     ##  ##    ##   ########   ########   ########   ##     ##  
	*/
	/* Fonctions exécutées au scroll */
	var scrollHandler = function() {
		var scrollTop = $(window).scrollTop();
		
		// /* EXEMPLE */
		// if (scrollTop > 380) {
		// 	$('.header').addClass('prestuck');
		// }
		// else {
		// 	$('.header').removeClass('prestuck');
		// }
	};

	/*
	##          #######      ###     ########   ########   ########   
	##         ##     ##    ## ##    ##     ##  ##         ##     ##  
	##         ##     ##   ##   ##   ##     ##  ##         ##     ##  
	##         ##     ##  ##     ##  ##     ##  ######     ########   
	##         ##     ##  #########  ##     ##  ##         ##   ##    
	##         ##     ##  ##     ##  ##     ##  ##         ##    ##   
	########    #######   ##     ##  ########   ########   ##     ##  
	*/

	showLoader = function(url) {
		tl = new TimelineLite();
		tl.pause();
		tl.add([
			// On peut chainer les évènements TweenMax ici. Example :
			// TweenMax.fromTo( $pan2l, 0,   { opacity: 0 }, { opacity: 1, delay: 0.10 } ),
			// TweenMax.fromTo( $pan3l, 0,   { opacity: 0 }, { opacity: 1, delay: 0.20 } ),
			// TweenMax.fromTo( $logo,  0.1, { opacity: 0 }, { opacity: 1, delay: 0.20 } )
		]);
		tl.call(function() {
			$(window).scrollTop(0);
			if( !pageAjax ){
				// A la fin de l'anim, on redirige vers la nouvelle URLs
				window.location.href = url;
			}else{
				// Exécution de la fonction qui va charger le nouveau contenu en ajax
				ajaxUrl.perform_ajax_request( url );
			}
		});
		tl.play();
	};

	var hideLoader = function() {
		// On lance l'animation de révélation de la page
		tl = new TimelineLite();
		tl.pause();
		tl.call(function() {
			initScrollAnimations();
		});
		tl.add([
			// On peut chainer les évènements TweenMax ici. Example :
			// TweenMax.fromTo( $pan1, 0.4, { x: '0' }, { x: '100%', delay: 0 } ),
			// TweenMax.fromTo( $pan2, 0.4, { x: '0' }, { x: '100%', delay: 0.15 } ),
			// TweenMax.fromTo( $logo, 0.2, { opacity: 1 }, { opacity: 0, delay: 0  } )
		], [], this, 1);	
		tl.play();
	};

	/*	Ajout d'un loader sur le chargement initial d’une page 
		Uniquement si la fonction de transition de page est active 
	*/
	if ( pageTransition ) {
		$('body').imagesLoaded( { background: true })
		.always( function(instance) {
			hideLoader();
		});
	}

	/*
	####  ##    ##   ####  ########   
	 ##   ###   ##    ##      ##      
	 ##   ####  ##    ##      ##      
	 ##   ## ## ##    ##      ##      
	 ##   ##  ####    ##      ##      
	 ##   ##   ###    ##      ##      
	####  ##    ##   ####     ##      
	*/

	function getUrlVars() {
		var vars = {};
		var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
			vars[key] = value;
		});
		return vars;
	}

	// Charge la function permettant de gérer le chargement des pages via AJAX
	if( pageAjax ){
		ajaxUrl.init();
	}

	var pageInit = function() {

		/*
		 ######     #######    #######   ##    ##   ####  ########   
		##    ##   ##     ##  ##     ##  ##   ##     ##   ##         
		##         ##     ##  ##     ##  ##  ##      ##   ##         
		##         ##     ##  ##     ##  #####       ##   ######     
		##         ##     ##  ##     ##  ##  ##      ##   ##         
		##    ##   ##     ##  ##     ##  ##   ##     ##   ##         
		 ######     #######    #######   ##    ##   ####  ########   
		*/

		switch( $('html').attr('lang') ){

			case "fr-FR":
				cookieText = "Nous diffusons des cookies afin d’analyser le trafic sur ce site. Les informations concernant l’utilisation que vous faites de notre site nous sont transmises dans cette optique.";
				acceptText = "J'accepte";
				break;

			default:
				cookieText = "We distribute cookies to analyze the traffic on this site. The information concerning the use you make of our site is transmitted to us in this perspective.";
				acceptText = "I accept";
				break;

		}

		$.cookieBar({
			message:       cookieText,
			acceptText:    acceptText,
			declineButton: false,
			expireDays:    30,
			fixed:         true,
			zindex:        10000
		});

		if(jQuery.cookieBar('cookies')){
			//Google Analytics or other code here
		}

		// Déclaration des évènements
		$(window).on('resize orientationchange', addEndEvent);
		$(window).on('resizeEnd', resizeHandler);
		$(window).on('scroll', scrollHandler);
		$(window).on('load', resizeHandler);
		$('body').on('reveal', '.sr', scrollRevealHandler);
		
		// $(window).trigger('resize'); // Joue la fonction resizeHandler()
		formLoader();                // Affiche un 'cache' à la validation d’un form CF7

		/* Autres scripts qui doivent être initialisés */
		// slider.init();
		$('.data-mh').matchHeight();

		// Local smooth scroll sur les liens vers des ancres
		if ($('.localscroll').length > 0) {
			$('.localscroll').localScroll( {
				hash: true
			});
			$.localScroll.hash();
		}

		// Fitvids = video embed responsive
		if ($('.fitvids').length > 0) {
			$('.fitvids').fitVids();
		}

		// Transmission des liens vers la fonction linkHandler()
		$('[data-link]').click(function(e) {
			linkHandler( $(this) );
		}).find('a').click(function(e) {
			e.stopPropagation();
		});

		$('a').click(function(e) {
			e.preventDefault();
			linkHandler( $(this) );
		});

		// Charge la function permettant de gérer le chargement des pages via AJAX
		if( pageAjax ){
			ajaxUrl();
		}

		$('.toggle-menu').on('click', function(){
			$('body').toggleClass('nav-open');
		});

		$.extend(true, $.magnificPopup.defaults, {
			tLoading: 'chargement...',
			fixedContentPos: "auto"
		});

		var totalPanier = function(){
			total = 0;
			$('.vin_qte').each(function(e){
				qte   = $(this).val();
				price = $(this).data('price');
				total += qte * price;
			});
			$('.form-total span').number( total, 2, ',', ' ' );
		};

		var initPanier = function(){

			$('.qte_add').unbind('click').click(function(){

				qte   = parseInt( $(this).prev('input').val() ) + 1;
				$(this).prev('input').val( qte ).trigger('change');

			});

			$('.qte_remove').unbind('click').click(function(){

				if( $(this).next('input').val() > 0 ){
					$(this).next('input').val( parseInt( $(this).next('input').val() ) - 1 ).trigger('change');
				}

			});

			$('.vin_qte').on('change', function(){
				qte   = $(this).val();
				price = $(this).data('price');
				id    = $(this).data('id');
				total = qte * price;
				// $(this).closest('.row').find('._p_vin_total').html( qte * price ).number( true, 2, ',', ' ' );
				$(this).closest('.row').find('._p_vin_total').number(total, 2, ',', ' ');

				var url  = jQuery(".panier-content").attr('action');
				jQuery.ajax({
			        url    : url,
			        type   : 'GET',
			        data : 'update_vin='+id+'&qte='+qte
			    });
			    
				totalPanier();

			});

			$('.panier-back').unbind('click').click(function(e){
				e.preventDefault();
				$('input[type="hidden"]').val(0);
				$('.form input, .form textarea').addClass('ignoreMe');
				setTimeout(function(){
					$('form').submit();
				}, 10);
			});
			formSubmit();
			formEvent();
		};

		var formSubmit = function(){

			$('form').unbind('submit').submit(function(){

				if($(this).validationEngine('validate')){

					var data = jQuery(this).serialize();
					var url  = jQuery(this).attr('action');
				    
				    $.magnificPopup.close();

					$.magnificPopup.open({
						items: {
							type: 'ajax',
							src: url
						},
						ajax: {
							settings: {
								data : data,
								method : 'POST'
							}
						},
						showCloseBtn: false,
						callbacks: {
						    ajaxContentAdded: function() {
								initPanier();				
						    }
						}
					});

				}

				return false;
			});
		};

		$('.ajax-cart').on('click', function(e){

			e.preventDefault();
			var url = $(this).attr('href');

			console.log( url );

			$.magnificPopup.close();

			setTimeout(function(){

				$.magnificPopup.open({
					items: {
						src: url,
						type: 'ajax'
					},
					showCloseBtn: false,
					callbacks: {
					    ajaxContentAdded: function() {
							initPanier();
					    }
					}
				});

			}, 10);
			
		});

		$(document).on('click', '.panier-close, .popup-close', function(){
			$.magnificPopup.close();
		});

	};

	// Functions à réinitialisées après un chargement de page via ajax
	afterAjax = function(){

		$('.data-mh').matchHeight();
		resizeParallax();

	};

	// Initialisation de toutes les fonctions utiles au chargement de la page
	pageInit();

	// if( $('.title-vin').length > 0 ){
	// 	new SplitText($('.title-vin'),{
	// 		type:       'words',
	// 		wordsClass: 'split-title-vin'
	// 	});
	// }

	$('.editor-text img').wrap('<div class="img-wrapper sr--item"></div>');

	// var mainController = new ScrollMagic.Controller();

	// var tweenBanner = TweenMax.to(".home-video-content", 0.5, {opacity: 0, top: "-=200"});
	// var sceneBanner = new ScrollMagic.Scene({ duration: ( $('.home-video').height() ) })
	// 			.setTween(tweenBanner)
	// 			.addTo(mainController);

	// build scenes
	// $('[data-header-theme]').each(function(){
	// 	headerClass = $(this).attr('data-header-theme');
	// 	new ScrollMagic.Scene({ triggerElement: $(this), duration: $(this).height() + $('.header').outerHeight() })
	// 		.setClassToggle('.header','header-dark')
	// 		.triggerHook(.2)
	// 		// .addIndicators() // add indicators (requires plugin)
	// 		.addTo(mainController);
	// });

	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var navbarHeight = $(".header").outerHeight();

	$(window).scroll(function(event) {
		didScroll = true;
	});

	setInterval(function() {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 250);

	function hasScrolled() {
		var st = $(this).scrollTop();

		// Make sure they scroll more than delta
		if (Math.abs(lastScrollTop - st) <= delta) return;

		// If they scrolled down and are past the navbar, add class .nav-up.
		// This is necessary so you never see what is "behind" the navbar.
		if (st > lastScrollTop && st > navbarHeight) {
		// Scroll Down
			$("body").removeClass("nav-down").addClass("nav-up");
		} else {
		// Scroll Up
			if (st + $(window).height() < $(document).height()) {
				$("body").removeClass("nav-up").addClass("nav-down");
			}
		}
		lastScrollTop = st;

		if( lastScrollTop === 0 ){
			$("body").removeClass("nav-up").removeClass("nav-down");
		}

	}

	$('.home-slider-slick').on('beforeChange', function(){

		$('.slick-active').find('.wine-item').removeClass('wine-item--show');

	}).on('init afterChange', function(){

		$('.slick-active').find('.wine-item').addClass('wine-item--show');

	}).slick({
		dots: false,
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 3,
		speed:600,
		prevArrow: $('.home-slider-nav--prev'),
		nextArrow: $('.home-slider-nav--next'),
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}
		]
	});

	// Exemple d'utilisation du plugin Mcube Gmaps
	$('.map').mcubeGmaps({
		bounds:  false, // default : true
		overlay: false//, // default : true
		// styles:  [{"featureType":"landscape","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},{"featureType":"poi","stylers":[{"saturation":-100},{"lightness":51},{"visibility":"simplified"}]},{"featureType":"road.highway","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"road.arterial","stylers":[{"saturation":-100},{"lightness":30},{"visibility":"on"}]},{"featureType":"road.local","stylers":[{"saturation":-100},{"lightness":40},{"visibility":"on"}]},{"featureType":"transit","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"administrative.province","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"on"},{"lightness":-25},{"saturation":-100}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#ffff00"},{"lightness":-25},{"saturation":-97}]}]
	});

	$grid = $('.image-gallery');
	$grid.isotope({
		itemSelector: '.gallery-item',
		percentPosition: true,
		masonry: {
			columnWidth: '.gallery-sizer'
		}
	});
	$grid.imagesLoaded().progress( function() {
		$grid.isotope('layout');
	});

	$('.image-gallery').each(function() { // the containers for all your galleries
	    $(this).find('a').magnificPopup({
	        type: 'image',
	        gallery: {
	          enabled:true
	        },
	        mainClass: 'mfp-fade'
	    });
	});

	splitTitle = new SplitText( $('.split-text') ,{
		type:       'words',
		wordsClass: 'split-text-word'
	});

	formEvent();

})(jQuery);
